// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddProject_custom-form-scroll__zgv1c {
  padding-right: 8px;
}

.AddProject_ant-modal-body__Q\\+RDL {
  padding-right: 12px !important;
}

.AddProject_ant-picker__n8Dis,
.AddProject_ant-input__eon4v {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/AddProject.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEE;EACE,8BAAA;AACJ;;AAEE;;EAEE,WAAA;AACJ","sourcesContent":[".custom-form-scroll {\n    padding-right: 8px;\n  }\n  \n  .ant-modal-body {\n    padding-right: 12px !important;\n  }\n  \n  .ant-picker,\n  .ant-input {\n    width: 100%;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-form-scroll": `AddProject_custom-form-scroll__zgv1c`,
	"ant-modal-body": `AddProject_ant-modal-body__Q+RDL`,
	"ant-picker": `AddProject_ant-picker__n8Dis`,
	"ant-input": `AddProject_ant-input__eon4v`
};
export default ___CSS_LOADER_EXPORT___;
